export const urlServer = process.env.REACT_APP_API_URL!;
